import React, { VFC } from 'react';
import { WrappedFieldArrayProps } from 'redux-form';

import HOCGroup from '~/components/Group/HOC';
import { DataInquiryMessagesProps } from '~/datas/props';

import Item from './Item';

const DataInquiryMessagesRender: VFC<
  WrappedFieldArrayProps & DataInquiryMessagesProps
> = ({ display, espaceId, fields, label }) => (
  <HOCGroup
    bodyProps={{ className: 'bg-transparent border-none md:px-0' }}
    display={display}
    title={label}
  >
    {fields.length > 0 ? (
      <div>
        <div className="-my-6 flex flex-col space-y-3">
          {fields.map((name, fieldIndex, allfields) => (
            <Item
              key={name}
              data={allfields.get(fieldIndex)}
              espaceId={espaceId}
              index={fieldIndex}
              nbMessages={allfields.length}
            />
          ))}
        </div>
      </div>
    ) : (
      <p>Aucun message</p>
    )}
  </HOCGroup>
);

export default DataInquiryMessagesRender;
